<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chỉnh sửa" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" text="Xóa" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo" title="Thông tin Quyền hạn" :active.sync="popupDetailsPermission"
                  v-if="popupDetailsPermission" id="details-permission">
            <PermissionInformation :permissionId="params.data.id"></PermissionInformation>
        </vs-popup>
    </div>
</template>

<script>

import PermissionInformation from "../PermissionInformation";
export default {
    name: 'CellRendererActions',
    components: {
        PermissionInformation
    },
    data() {
        return {
            popupDetailsPermission: false,
        }
    },
    methods: {
        editRecord() {
            this.popupDetailsPermission = true;
        },
        showUpdateSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Cập nhật thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá quyền này không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$oauth.post('/permission-function-global/delete/' + this.params.data.id, {}).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$store.commit('DELETE_NOTIFY', true);
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-permission-success', () => {
            this.popupDetailsPermission = false;
        })
    }
}
</script>

<style lang="scss">
#details-permission {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
